import AudioContentDetailLayout from 'src/components/AudiocontentDetail/Layout';

import {
  AudioDetail,
  GetAudioDetailQueryResult,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
} from 'src/api/audioContent/audioContent.graphql';

import {
  DataAudioContentResponse,
  fetchBySlug,
} from 'src/api/audioContent/dataAudioContent';
import {
  GetStaticPaths,
  GetStaticProps,
  GetStaticPropsContext,
  GetStaticPropsResult,
} from 'next';
import { NextArticlePath, fetchAllSlugs } from 'src/api/article/dataArticle';
import Header from 'src/components/AudiocontentDetail/Header';

type BookPageProps = {
  articleSlugs: NextArticlePath[];
  audioContentQueryData: GetAudioDetailQueryResult;
  messages: {
    [index: string]: string;
  };
};

const IndexPage = (props: BookPageProps): JSX.Element => {
  const { audioContentQueryData } = props;
  const { articleSlugs } = props;
  if (audioContentQueryData.error) {
    return <div>AUDIO CONTENT NOT FOUND</div>;
  }
  const { data } = audioContentQueryData;
  const audioDetail = data?.audioDetail as AudioDetail;
  return (
    <>
      <Header audioContent={audioDetail} />
      <AudioContentDetailLayout
        articles={articleSlugs}
        audiodetail={audioDetail}
      />
    </>
  );
};

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => ({
  paths: [], // return array paths or empty to indicate that no page needs be created at build time
  fallback: 'blocking', // indicates the type of fallback
});

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<BookPageProps>> => {
  const audioContentSlug: string = context.params?.slug as string;
  const data: DataAudioContentResponse = await fetchBySlug(audioContentSlug);

  if (data.error || data?.response?.data?.audioDetail?.audio?.beekTeExplica) {
    return {
      redirect: {
        destination: '/listas',
        statusCode: 301,
      },
    };
  }

  const responseAudio: GetAudioDetailQueryResult = data.response!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
  const dataAudio = responseAudio?.data;

  const legacySlug = dataAudio?.audioDetail?.legacySlug;

  if (legacySlug) {
    return {
      redirect: {
        destination: `/libros/${legacySlug}`,
        statusCode: 301,
      },
    };
  }

  let dataArticle: NextArticlePath[] = await fetchAllSlugs();

  if (!dataArticle) {
    dataArticle = [];
  }

  return {
    props: {
      audioContentQueryData: responseAudio,
      articleSlugs: dataArticle,
      messages: {
        ...require(`src/messages/audioContent/${context.locale}.json`),
        ...require(`src/messages/article/${context.locale}.json`),
      },
    },
  };
};

export default IndexPage;
